//@ts-check
import cleanPath from './cleanPath';
/**
 * @type {import("./types").encodePathForUriType}
 */

export default function encodePathForUri(path) {
  if (!path) return path;
  return cleanPath(path).split('/').map(function (part) {
    return encodeURI(part);
  }).join('/');
}